module.exports = __webpack_public_path__ + "img/edge_divers_tel_fixe.bd418757.svg";